import {
    defaultBaseQuery,
    transformErrorResponse,
    transformRequest,
    transformSuccessResponse
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const NodalOfficerApi = createApi({
    reducerPath: 'NodalOfficerApi',
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        getNodalOfficerAppliedScholarships: builder.query({
            query: (params) => ({
                url: `scholarship/nodal-officer/applied`,
                method: 'GET',
                params: params,
                transformRequest: transformRequest
            }),
            transformErrorResponse: transformErrorResponse,
            transformResponse: transformSuccessResponse
        }),
        getNodalOfficerApplicationById: builder.query({
            query: ({ scholarshipId, uskId }) => ({
                url: `scholarship/applied/${scholarshipId}`,
                method: 'GET',
                params: { uskId },
                transformRequest: transformRequest
            }),
            transformErrorResponse: transformErrorResponse,
            transformResponse: transformSuccessResponse
        }),
        updateScholarshipStatus: builder.mutation({
            query: ({ id, ...body }) => ({
                url: `scholarship/status/${id}`,
                method: "PATCH",
                body,
                transformRequest: transformRequest,
            }),
            transformErrorResponse: transformErrorResponse,
            transformResponse: transformSuccessResponse,
        }),
        getScholarshipCardStatistics: builder.query({
            query: (params) => ({
                url: `scholarship/nodal-officer/counts`,
                method: 'GET',
                params: params,
                transformRequest: transformRequest
            }),
            transformErrorResponse: transformErrorResponse,
            transformResponse: transformSuccessResponse
        })
    })
});

export const {
    useLazyGetNodalOfficerAppliedScholarshipsQuery,
    useGetNodalOfficerAppliedScholarshipsQuery,
    useLazyGetNodalOfficerApplicationByIdQuery,
    useUpdateScholarshipStatusMutation,
    useGetScholarshipCardStatisticsQuery,
    useLazyGetScholarshipCardStatisticsQuery
} = NodalOfficerApi;

export default NodalOfficerApi;
